import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-delete-account-confirm',
  templateUrl: './delete-account-confirm.component.html',
  styleUrls: ['./delete-account-confirm.component.scss'],
})
export class DeleteAccountConfirmComponent {
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  constructor(private localizationService: LocalizationService) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  cancel(): void {
    this.stepperChange.emit((this.stepper = 1));
  }

  confirmDelete(): void {
    // The last-active-PMA "unable to delete" case is handled earlier, in
    // account-details before this confirmation step is shown, so confirming
    // here always proceeds to the verification step.
    this.stepperChange.emit((this.stepper = 8));
  }
}
